import { render, staticRenderFns } from "./SectionDirectories.vue?vue&type=template&id=4bfd9603&"
import script from "./SectionDirectories.vue?vue&type=script&lang=js&"
export * from "./SectionDirectories.vue?vue&type=script&lang=js&"
import style0 from "./SectionDirectories.vue?vue&type=style&index=0&lang=scss&module=w&"




function injectStyles (context) {
  
  this["w"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports